import React from 'react';
import EditorItalic from '@wix/da-ds/pkg/Icons/24x24/EditorItalic';
import { ButtonProps } from './types';
import { isExtensionInstalled } from '../../utils/tiptap';
import { useTranslation } from 'react-i18next';

import EditorIconButton from '../_partials/EditorIconButton';

const Italic: React.FC<ButtonProps> = ({
  editor,
  hideWhenNotEnabled = true,
}) => {
  const { t } = useTranslation('editor');
  if (
    !editor.isEditable ||
    (hideWhenNotEnabled && !isExtensionInstalled(editor, 'italic'))
  ) {
    return null;
  }
  return (
    <EditorIconButton
      featureId="format:italic"
      icon={EditorItalic}
      onClick={() => editor.chain().focus().toggleItalic().run()}
      disabled={!editor.can().chain().focus().toggleItalic().run()}
      isActive={editor.isActive('italic')}
      tooltipText={t('button.italic.tooltip')}
      aria-label={t('button.italic.tooltip')}
    />
  );
};
Italic.displayName = 'Italic';

export default Italic;
